











































































































import Vue from 'vue'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import moment from 'moment-timezone'
import axios from 'axios'

import {
  LIVE_DASH_STOP_POLLING_TIMESTAMP,
  LIVE_DASHBOARD_TYPES,
  titleByLiveDashboardTypes,
} from '@/constants/live-dashboard'
import { ONE_MINUTE_TIMESTAMP } from '@/components/patient-stats/graphs/mapping-chart-options/constants'

import { ModuleNames } from '@/store/module-names'
import {
  ActionNames as PatientWithLiveDataActionNames,
  GetterNames as PatientWithLiveDataGetterNames,
  MutationNames as PatientWithLiveDataMutationNames,
} from '@/store/modules/patient-with-live-data-latest/keys'
import { ActionNames as PatientActionNames, GetterNames as PatientGetterNames } from '@/store/modules/patient/keys'
import {
  ActionNames as ExerciseProgramActionNames,
  GetterNames as ExerciseProgramGetterNames,
} from '@/store/modules/exercise-program/keys'
import { ActionNames as PatientExerciseActionNames } from '@/store/modules/exercise/keys'
import { LivePatientsWithHistories } from '@/store/modules/patient-with-live-data-latest/types'

import { getPatientName } from '@/utils/patients'

import ExerciseProgramExerciseSessionLivePatientStatusCard from '@/components/exercise-programs/components/ExerciseProgramExerciseSessionLivePatientStatusCard.vue'
//import LiveDashboardFilter from '@/components/live-dashboard/LiveDashboardFilter.vue'
import ExerciseProgramEndLiveExerciseSessionDialog from '@/components/exercise-programs/forms/ExerciseProgramEndLiveExerciseSessionDialog.vue'
import ExerciseProgramLiveExerciseSessionIsCompleteDialog from '@/components/exercise-programs/forms/ExerciseProgramLiveExerciseSessionIsCompleteDialog.vue'
import StatusBadge from '@/components/sub-components/StatusBadge.vue'

const enum Filter {
  Live = 'live',
  All = 'all',
}
const filterOptions = [
  { label: 'Live Patients', value: Filter.Live },
  { label: 'ALL', value: Filter.All },
]

export default Vue.extend({
  components: {
    ExerciseProgramExerciseSessionLivePatientStatusCard,
    //LiveDashboardFilter,
    ExerciseProgramEndLiveExerciseSessionDialog,
    ExerciseProgramLiveExerciseSessionIsCompleteDialog,
    StatusBadge,
  },
  data() {
    return {
      currentTab: LIVE_DASHBOARD_TYPES.OxygenSaturations,
      filterOptions,
      selectedFilter: filterOptions[0],
      stopPollingTimeout: null,
      pollingTime: 3000,
      isInitialized: false,
      isStoppedPolling: false,
      showResumeModal: false,

      //program/session specific
      exerciseSessionId: null,
      showEndExerciseSessionDialog: false,
      isSavingExerciseSessionData: false,
      showExerciseSessionIsCompleteDialog: false,

      //for window focus
      hidden: '',
      visibilityChange: '',
    }
  },
  computed: {
    formattedCurrentDate() {
      return moment().format('dddd Do MMMM, YYYY')
    },
    formattedExerciseSessionDate() {
      return moment(this.exerciseSession.date).format('dddd Do MMMM, YYYY')
    },
    formattedExerciseSessionStartTime() {
      return moment.unix(this.exerciseSession.startTimestamp).format('HH:mm a')
    },
    formattedExerciseSessionEndTime() {
      if (this.exerciseSessionIsComplete) {
        return moment.unix(this.exerciseSession.endTimestamp).format('HH:mm a')
      }
      return ''
    },
    formattedExerciseSessionDuration() {
      if (this.exerciseSessionIsComplete) {
        return `${moment
          .unix(this.exerciseSession.endTimestamp)
          .diff(moment.unix(this.exerciseSession.startTimestamp), 'minutes')} mins`
      }
      return ''
    },
    lastUpdateLabel() {
      return moment(this.lastUpdate).format('hh:mm:ss A')
    },
    exerciseSession() {
      return this.exerciseProgram.sessions.find(session => session.id === this.exerciseSessionId)
    },
    flatPatientExerciseRecords() {
      const records = {}
      this.exerciseSession.patientExerciseIds.forEach(item => {
        records[item.patientId] = item.exerciseId
      })
      return records
    },
    exerciseSessionHasStartTimestamp() {
      return this.exerciseSession.startTimestamp ? true : false
    },
    exerciseSessionIsComplete() {
      return this.exerciseSession.endTimestamp ? true : false
    },
    sessionStatusLabelColor() {
      return this.exerciseSessionIsComplete ? '#0f45cd' : '#1fc151'
    },
    sessionStatusLabelShouldBlink() {
      return !this.exerciseSessionIsComplete && !this.isStoppedPolling
    },
    exerciseSessionParticipantIds() {
      return this.exerciseSession.participants
    },
    exerciseSessionParticipants() {
      return (this.livePatientsWithHistories as LivePatientsWithHistories[])
        .filter(patientsWithHistories => this.exerciseSessionParticipantIds.includes(patientsWithHistories.id))
        .sort((a, b) =>
          getPatientName(a)
            .toLowerCase()
            .localeCompare(getPatientName(b).toLowerCase())
        )
    },
    liveExerciseSessionParticipants() {
      return this.exerciseSessionParticipants.filter(participant => {
        return participant.oxygenSaturations.length || participant.pulseRates.length
      })
    },
    ...mapState(ModuleNames.patientWithLiveDataLatest, ['lastUpdate', 'livePatientsWithHistories']),
    ...mapGetters(ModuleNames.patient, [PatientGetterNames.activePatients]),
    ...mapGetters(ModuleNames.patientWithLiveDataLatest, [PatientWithLiveDataGetterNames.patientWithLiveDataLatests]),
    ...mapGetters(ModuleNames.exerciseProgram, {
      exerciseProgram: ExerciseProgramGetterNames.chosenExerciseProgram,
      exerciseProgramId: ExerciseProgramGetterNames.chosenExerciseProgramId,
    }),
  },
  created() {
    this.startWindowFocusHandling()
  },
  async mounted() {
    //fetch programs in case of page refresh
    if (!this[ExerciseProgramGetterNames.chosenExerciseProgramId]) {
      await this[ExerciseProgramActionNames.getExercisePrograms]()
      this[ExerciseProgramActionNames.setChosenExerciseProgramId](this.$route.params.program_id)
    }
    //set session Id
    this.exerciseSessionId = this.$route.params.exercise_session_id
    /* Could maybe look at moving this action if page reloads are an issue. Currently live data is cleared on mount - but we could look at doing this on session start / end instead */
    this[PatientWithLiveDataMutationNames.resetPatientWitLiveData]()
    await this[PatientActionNames.getPatients]()
    await this.fetchPatientWithLiveDataLatests()
    this.resumePolling()
    this.isInitialized = true
    if (!this.exerciseSessionHasStartTimestamp) {
      await this.startLiveExerciseSession()
    }
  },
  beforeDestroy(): void {
    this.stopPolling()
    document.removeEventListener(this.visibilityChange, this.handleVisibilityChange, false)
  },
  methods: {
    resumePolling() {
      console.log(new Date(), 'start polling')
      this.isStoppedPolling = false
      this.hideResumeDialog()
      this.startPolling()
    },
    startPolling() {
      if (this.isStoppedPolling) return
      setTimeout(async () => {
        try {
          await this.fetchPatientWithLiveDataLatests()
        } catch (e) {
          console.log('error', e)
        }
        this.startPolling()
      }, this.pollingTime)
    },
    async fetchPatientWithLiveDataLatests() {
      await this[PatientWithLiveDataActionNames.getPatientWithLiveDataLatests]({
        startTimestamp: new Date().getTime() - ONE_MINUTE_TIMESTAMP,
        endTimestamp: new Date().getTime(),
      })
    },
    async startLiveExerciseSession() {
      console.log(`starting exercise session`)
      await this[ExerciseProgramActionNames.patchExerciseProgramSession]({
        id: this.exerciseSessionId,
        attributes: {
          startTimestamp: moment().unix(),
        },
      })
    },
    async endLiveExerciseSession() {
      this.isSavingExerciseSessionData = true
      await this[ExerciseProgramActionNames.patchExerciseProgramSession]({
        id: this.exerciseSessionId,
        attributes: {
          endTimestamp: moment().unix(),
        },
      })
      this.isSavingExerciseSessionData = false
      this.showEndExerciseSessionDialog = false
      this.showExerciseSessionIsCompleteDialog = true
      this.stopPolling()
    },
    pushPatientRecordRoute() {
      this.showExerciseSessionIsCompleteDialog = false
      this.$router.push({
        name: 'exercises',
        query: {
          from_exercise_program: this.exerciseProgramId,
        },
      })
    },
    async patchPatientExercise(e) {
      console.log(
        `patching patient-exercise ${this.flatPatientExerciseRecords[e.patientId]} with ${e.sessionStage} reading`
      )
      console.log(e.vitalSignReadings)
      await this[PatientExerciseActionNames.patchExercise]({
        id: this.flatPatientExerciseRecords[e.patientId],
        attributes: {
          vitalSignReadings: e.vitalSignReadings,
        },
      })
    },
    stopPolling() {
      this.isStoppedPolling = true
    },
    showResumeDialog() {
      this.showResumeModal = true
    },
    hideResumeDialog() {
      this.showResumeModal = false
    },
    startWindowFocusHandling() {
      // https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
      if (typeof document.hidden !== 'undefined') {
        // Opera 12.10 and Firefox 18 and later support
        this.hidden = 'hidden'
        this.visibilityChange = 'visibilitychange'
      } else if (typeof (document as any).msHidden !== 'undefined') {
        this.hidden = 'msHidden'
        this.visibilityChange = 'msvisibilitychange'
      } else if (typeof (document as any).webkitHidden !== 'undefined') {
        this.hidden = 'webkitHidden'
        this.visibilityChange = 'webkitvisibilitychange'
      }

      document.addEventListener(this.visibilityChange, this.handleVisibilityChange, false)
    },
    handleVisibilityChange() {
      if (document[this.hidden]) {
        console.log(new Date(), 'lost focus')
        this.stopPollingTimeout = setTimeout(() => {
          console.log(new Date(), 'stop polling')
          this.stopPolling()
        }, LIVE_DASH_STOP_POLLING_TIMESTAMP)
      } else {
        window.clearTimeout(this.stopPollingTimeout)
        if (this.isStoppedPolling) this.showResumeDialog()
      }
    },
    /*
    shouldShowCard(patientWithHistories: LivePatientsWithHistories) {
      if (this.selectedFilter.value === Filter.All) return true
      return patientWithHistories.oxygenSaturations.length || patientWithHistories.pulseRates.length
    },
    */
    ...mapActions(ModuleNames.exerciseProgram, [
      ExerciseProgramActionNames.getExercisePrograms,
      ExerciseProgramActionNames.setChosenExerciseProgramId,
      ExerciseProgramActionNames.patchExerciseProgramSession,
    ]),
    ...mapActions(ModuleNames.patient, [PatientActionNames.getPatients]),
    ...mapActions(ModuleNames.exercise, [PatientExerciseActionNames.patchExercise]),
    ...mapMutations(ModuleNames.patientWithLiveDataLatest, [PatientWithLiveDataMutationNames.resetPatientWitLiveData]),
    ...mapActions(ModuleNames.patientWithLiveDataLatest, [
      PatientWithLiveDataActionNames.getPatientWithLiveDataLatests,
    ]),
  },
})
